// Global variable to save the scroll position before moving to Step 2
let savedScrollPos = 0;

document.addEventListener("DOMContentLoaded", () => {
  console.log("✅ Consolidated JavaScript loaded!");

  // Helper function to safely add active-boxi class
  function activateBoxText(index) {
    console.log(`🔹 Activating box-text for index: ${index}`);
    const allBoxTexts = document.querySelectorAll(".box-text");
    allBoxTexts.forEach(box => {
      box.classList.remove("active-boxi");
      console.log(`Removed active-boxi from ${box.className}`);
    });
    console.log("🔸 Removed .active-boxi from all .box-text elements");

    let targetBoxes = document.querySelectorAll(`.box-text[data-index="${index}"]`);
    if (targetBoxes.length === 0) {
      targetBoxes = document.querySelectorAll(
        `.first-box .box-text[data-index="${index}"], .second-box .box-text[data-index="${index}"]`
      );
    }
    if (targetBoxes.length === 0) {
      targetBoxes = document.querySelectorAll(
        `.mainns-boxx[data-index="3"] .main-box .box-text[data-index="${index}"]`
      );
    }
    if (targetBoxes.length) {
      targetBoxes.forEach(targetBox => {
        targetBox.classList.add("active-boxi");
        // Force reflow for CSS transitions if needed.
        void targetBox.offsetHeight;
        console.log(`✅ Added .active-boxi to ${targetBox.className} with data-index="${index}"`);
      });
    } else {
      console.warn(`❌ No matching .box-text[data-index="${index}"] found. Check your HTML structure.`);
    }
  }

  // Global click event delegation for variant and product options
  document.addEventListener("click", (event) => {
    if (event.target.matches(".variant-option") || event.target.closest(".variant-option")) {
      const clickedElement = event.target.matches(".variant-option")
        ? event.target
        : event.target.closest(".variant-option");
      let index = clickedElement.getAttribute("data-index");
      console.log(`➡️ Clicked variant option with index: ${index}`);
      if (index) {
        activateBoxText(index);
      } else {
        console.warn("⚠️ No data-index attribute found on clicked element.");
      }
    } else if (event.target.matches(".product-optione") || event.target.closest(".product-optione")) {
      console.log("🖱️ Click detected on .product-optione");
      activateBoxText("0");
    } else if (event.target.matches("#back-step") || event.target.closest("#back-step")) {
      console.log("🔙 Click detected on #back-step");
      activateBoxText("0");
      // Instead of scrolling to top, scroll back to the saved scroll position
      window.scrollTo({ top: savedScrollPos, behavior: "smooth" });
    }
  });

  // Variant container event delegation
  const variantContainer = document.getElementById("variant-container");
  if (variantContainer) {
    variantContainer.addEventListener("click", (event) => {
      const target = event.target.closest("span.second-var-first input[data-index]");
      if (!target) return;
      let index = target.getAttribute("data-index");
      console.log(`👉 Variant container: clicked variant with index: ${index}`);
      if (index) {
        setTimeout(() => activateBoxText(index), 50);
      }
    });
  }

  // MutationObserver to reapply active-boxi on dynamic changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        const activeElement = document.querySelector(".box-text.active-boxi");
        if (activeElement) {
          const index = activeElement.getAttribute("data-index");
          if (index) {
            console.log("🔄 DOM changed, reapplying active-boxi");
            setTimeout(() => activateBoxText(index), 50);
          }
        } else {
          console.log("🔄 DOM changed, no active element found, applying default");
          setTimeout(() => activateBoxText("0"), 50);
        }
      }
    });
  });
  const observeTargets = [
    document.querySelector(".first-box"),
    document.querySelector(".second-box"),
    document.querySelector(".mainns-boxx[data-index='3']"),
    document.getElementById("variant-container")
  ];
  observeTargets.forEach(target => {
    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    }
  });
  setTimeout(() => activateBoxText("0"), 100);

  // Toggle custom dropdown
  window.toggleCustomDropdown = function() {
    var dropdownMenu = document.getElementById("customDropdownMenu");
    var dropdownArrow = document.querySelector(".custom-dropdown-arrow");
    if (dropdownMenu.style.display === "block") {
      dropdownMenu.style.display = "none";
      dropdownArrow.classList.remove("custom-flip");
    } else {
      dropdownMenu.style.display = "block";
      dropdownArrow.classList.add("custom-flip");
    }
  };

  // For Gallery: Remove duplicate thumbnails
  document.querySelectorAll(".product-optione").forEach(option => {
    option.addEventListener("click", function () {
      console.log("Product option clicked, waiting for gallery to load...");
      setTimeout(() => {
        const removeExtra = (className) => {
          const elements = document.querySelectorAll(`.${className}`);
          console.log(`Found ${elements.length} ${className} elements`);
          if (elements.length > 1) {
            for (let i = 1; i < elements.length; i++) {
              elements[i].style.display = "none";
              console.log(`Duplicate ${className} hidden`);
            }
          } else {
            console.log(`No duplicate ${className} found`);
          }
        };
        removeExtra("thumbnail-prev");
        removeExtra("thumbnail-next");
      }, 500);
    });
  });

  // Back Step & Thumbnail Button Visibility Management
  const backStepButtonGlobal = document.getElementById("back-step");
  const productOptions = document.querySelectorAll(".product-option");
  function hideThumbnailButtons() {
    document.querySelectorAll("button.thumbnail-prev, button.thumbnail-next").forEach(button => {
      button.style.display = "none";
    });
  }
  function showFirstThumbnailButtons() {
    hideThumbnailButtons();
    setTimeout(() => {
      const allPrevButtons = document.querySelectorAll("button.thumbnail-prev");
      const allNextButtons = document.querySelectorAll("button.thumbnail-next");
      if (allPrevButtons.length > 0) allPrevButtons[0].style.display = "block";
      if (allNextButtons.length > 0) allNextButtons[0].style.display = "block";
    }, 100);
  }
  if (backStepButtonGlobal) {
    backStepButtonGlobal.addEventListener("click", () => {
      hideThumbnailButtons();
      // Scroll back to the saved scroll position on back-step click
      window.scrollTo({ top: savedScrollPos, behavior: "smooth" });
    });
  }
  productOptions.forEach(option => {
    option.addEventListener("click", showFirstThumbnailButtons);
  });
  const thumbObserver = new MutationObserver(() => {
    hideThumbnailButtons();
    showFirstThumbnailButtons();
  });
  const thumbnailContainer = document.getElementById("thumbnail-container");
  if (thumbnailContainer) {
    thumbObserver.observe(thumbnailContainer, { childList: true, subtree: true });
  }
});

// jQuery for adding active classes to checked outlet options on page load
$(document).ready(function () {
  // On page load, add active classes to any checked outlet option
  $('.product-optione:checked').each(function() {
    $(this).addClass('yep-active');
    $(this).closest('.block-name').addClass('active-p');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  console.log("Script Loaded!");
  const productOptions = document.querySelectorAll(".product-option");
  const images = document.querySelectorAll(".pdp-new-img .label-pp");
  const radios = document.querySelectorAll(".b-heading-content");
  const rado = document.querySelectorAll(".mainns-boxx");
  const nextStepBtn = document.getElementById("next-step");
  const backStepBtn = document.getElementById("back-step");
  const step1 = document.getElementById("step-1");
  const step2 = document.getElementById("step-2");
  const stepNumber = document.getElementById("step-number");
  const progressBarElements = document.querySelectorAll(".s-progress-bar, .acti-here");

  productOptions.forEach(option => {
    option.addEventListener("change", function () {
      let selectedIndex = this.dataset.index;
      console.log(`Radio button selected: Index ${selectedIndex}`);
      images.forEach(image => image.classList.remove("active"));
      radios.forEach(radio => radio.classList.remove("activbe"));
      rado.forEach(rado => rado.classList.remove("activbe"));
      document.querySelector(`.pdp-new-img .label-pp[data-index="${selectedIndex}"]`)?.classList.add("active");
      let activeRadio = document.querySelector(`.b-heading-content[data-index="${selectedIndex}"]`);
      let activeRado = document.querySelector(`.mainns-boxx[data-index="${selectedIndex}"]`);
      if (activeRadio) {
        activeRadio.classList.add("activbe", "activbep");
      }
      if (activeRado) {
        activeRado.classList.add("activbe", "activbep");
      }
    });
  });

  nextStepBtn?.addEventListener("click", function () {
    console.log("Next step button clicked");
    // Save the current scroll position before moving to Step 2
    savedScrollPos = window.pageYOffset;
    let selectedOption = document.querySelector(".product-option:checked");
    if (!selectedOption) {
      alert("Please select an option before proceeding.");
      console.log("No product option selected, cannot proceed.");
      return;
    }
    // Ensure outlet defaults are set for all outlet groups.
    if (!document.querySelector("input[name='product-option-1']:checked")) {
      const defaultOutlet1 = document.querySelector("#option-1-1");
      if (defaultOutlet1) {
        defaultOutlet1.checked = true;
        defaultOutlet1.dispatchEvent(new MouseEvent("click", { bubbles: true }));
      }
    }
    if (!document.querySelector("input[name='product-option-2']:checked")) {
      const defaultOutlet2 = document.querySelector("#option-1-2");
      if (defaultOutlet2) {
        defaultOutlet2.checked = true;
        defaultOutlet2.dispatchEvent(new MouseEvent("click", { bubbles: true }));
      }
    }
    if (!document.querySelector("input[name='product-option-3']:checked")) {
      const defaultOutlet3 = document.querySelector("#option-1-3");
      if (defaultOutlet3) {
        defaultOutlet3.checked = true;
        defaultOutlet3.dispatchEvent(new MouseEvent("click", { bubbles: true }));
      }
    }
    console.log(`Moving to Step 2 with selection: ${selectedOption.value}`);
    step1.classList.add("hidden");
    step2?.classList.remove("hidden");
    stepNumber.textContent = "2";
    progressBarElements.forEach(el => el.classList.add("active"));
    // After transitioning, apply active classes for all checked outlet options.
    $('.product-optione:checked').each(function() {
      $(this).addClass('yep-active');
      $(this).closest('.block-name').addClass('active-p');
    });
    // Scroll to top after moving to Step 2.
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  backStepBtn?.addEventListener("click", function () {
    console.log("Back step button clicked. Returning to Step 1.");
    step1.classList.remove("hidden");
    step2?.classList.add("hidden");
    stepNumber.textContent = "1";
    progressBarElements.forEach(el => el.classList.remove("active"));
    // Scroll back to the saved scroll position after going back.
    window.scrollTo({ top: savedScrollPos, behavior: "smooth" });
  });

  document.querySelectorAll(".tooltip-container").forEach(item => {
    item.addEventListener("click", function (e) {
      // Prevent click from bubbling up so document click doesn't immediately hide tooltip
      e.stopPropagation();
      let tooltip = this.querySelector(".tooltip-text");
      let isVisible = tooltip.style.visibility === "visible";
      tooltip.style.visibility = isVisible ? "hidden" : "visible";
      tooltip.style.opacity = isVisible ? "0" : "1";
    });
  });

  // Hide tooltips when clicking outside any tooltip container
  document.addEventListener("click", function () {
    document.querySelectorAll(".tooltip-container .tooltip-text").forEach(tooltip => {
      tooltip.style.visibility = "hidden";
      tooltip.style.opacity = "0";
    });
  });

  const backButton = document.getElementById("back-step");
  let previousSelection = null;
  productOptions.forEach(option => {
    option.addEventListener("click", function () {
      const currentBlock = this.closest(".block-ctn");
      const currentRadioSS = currentBlock.closest(".radio-ss");
      const currentHeading = currentBlock.closest(".b-heading-content");
      const currentSelection = this.value;
      if (previousSelection && previousSelection !== currentSelection) {
        document.querySelector(`.block-ctn input[value='${previousSelection}']`)?.closest(".block-ctn").classList.remove("show-me");
      }
      document.querySelectorAll(".block-ctn").forEach(block => block.classList.remove("active"));
      currentBlock.classList.add("active");
      document.querySelectorAll(".radio-ss, .b-heading-content").forEach(el => el.classList.remove("show-me"));
      currentRadioSS.classList.add("show-me");
      currentHeading.classList.add("show-me");
      previousSelection = currentSelection;
    });
  });
  backButton?.addEventListener("click", function () {
    document.querySelectorAll(".radio-ss, .b-heading-content").forEach(el => el.classList.remove("show-me"));
    previousSelection = null;
    document.querySelectorAll(".block-ctn").forEach(block => block.classList.remove("active"));
    // Scroll back to saved scroll position on back-step click.
    window.scrollTo({ top: savedScrollPos, behavior: "smooth" });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const options = document.querySelectorAll(".product-option");
  const secondPart = document.querySelector(".second-part");
  const backStep = document.querySelector("#back-step");
  options.forEach(option => {
    option.addEventListener("click", function () {
      const index = this.getAttribute("data-index");
      secondPart.classList.remove("new-active-one", "new-active-two", "new-active-three");
      if (index === "1") {
        secondPart.classList.add("new-active-one");
      } else if (index === "2") {
        secondPart.classList.add("new-active-two");
      } else if (index === "3") {
        secondPart.classList.add("new-active-three");
      }
    });
  });
  backStep.addEventListener("click", function () {
    secondPart.classList.remove("new-active-one", "new-active-two", "new-active-three");
    // Scroll back to saved scroll position on back-step click.
    window.scrollTo({ top: savedScrollPos, behavior: "smooth" });
  });
});

//
// Gallery & Variant Update with Default Reapplication on Back
document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM fully loaded and parsed");
  let selectedVariantId = null;
  const productOptions = document.querySelectorAll('.product-option');
  const assignedProductOptions = document.querySelectorAll('.product-optione');
  const backStepButton = document.getElementById("back-step");
  const nextStepButton = document.getElementById("next-step");
  const checkoutButton = document.getElementById("checkout-btn");
  const mainImageContainer = document.getElementById("main-image");
  const thumbnailContainer = document.getElementById("thumbnail-container");
  const variantContainer = document.getElementById("variant-container");

  function clearGalleryAndVariants() {
    if (thumbnailContainer) thumbnailContainer.innerHTML = "";
    if (variantContainer) variantContainer.innerHTML = "";
    if (mainImageContainer) mainImageContainer.src = "";
  }

  function updateGallery(productHandle) {
    console.log("Updating gallery for product:", productHandle);
    fetch(`/products/${productHandle}.json`)
      .then(response => response.json())
      .then(data => {
        const product = data.product;
        if (!product) {
          console.error("No product data found");
          return;
        }
        clearGalleryAndVariants();
        if (product.images.length > 0) {
          mainImageContainer.src = product.images[0].src;
        }
        // Create thumbnail images
        product.images.forEach((image, index) => {
          const imgElement = document.createElement("img");
          imgElement.src = image.src;
          imgElement.classList.add("thumbnail");
          imgElement.dataset.index = index;
          imgElement.addEventListener("click", function () {
            mainImageContainer.src = image.src;
          });
          thumbnailContainer.appendChild(imgElement);
        });
        const prevArrow = document.createElement("button");
        prevArrow.innerHTML = "&larr;";
        prevArrow.classList.add("thumbnail-prev");
        const nextArrow = document.createElement("button");
        nextArrow.innerHTML = "&rarr;";
        nextArrow.classList.add("thumbnail-next");
        thumbnailContainer.parentNode.insertBefore(prevArrow, thumbnailContainer);
        thumbnailContainer.parentNode.appendChild(nextArrow);
        function isMobile() {
          return window.matchMedia("(max-width: 768px)").matches;
        }
        function updateThumbnailScroll(direction) {
          const scrollAmount = 100;
          if (isMobile()) {
            // On mobile, scroll vertically
            thumbnailContainer.scrollBy({ top: direction * scrollAmount, behavior: "smooth" });
          } else {
            thumbnailContainer.scrollBy({ left: direction * scrollAmount, behavior: "smooth" });
          }
        }
        prevArrow.addEventListener("click", function () {
          updateThumbnailScroll(-1);
        });
        nextArrow.addEventListener("click", function () {
          updateThumbnailScroll(1);
        });
        // Update variant options
        variantContainer.innerHTML = "";
        product.variants.forEach((variant, index) => {
          const variantClone = document.createElement("div");
          variantClone.classList.add("variant");
          const price = Math.round(variant.price);
          const comparePrice = variant.compare_at_price ? Math.round(variant.compare_at_price) : null;
          variantClone.innerHTML = `
                        <label class="variant-label" data-index="${index}">
                        <span class="second-var-first">
                            <input type="radio" data-index="${index}" name="variant" id="variant-${variant.id}" value="${variant.id}" class="variant-option">
                            <span class="title-var">${variant.title}</span>
                            </span>
                            <span class="pp-var">
                            ${price ? `<span class="variant-price">$${price}</span>` : ""}
                            ${comparePrice ? ` <span class="old-price" style="text-decoration: line-through; color: red;">$${comparePrice}</span>` : ""}
                            </span>
                        </label>
                    `;
          const bundleVariants = {
            47885716554050: window.nema_tenthreezero_probundle,
            47885716586818: window.nema_tenthreezero_teslaprobundle,
            47886984413506: window.nema_onefourthreezero_probundle,
            47886984511810: window.nema_onefourthreezero_teslaprobundle,
            47888392192322: window.nema_onefourfivezero_outletupgradebundle,
            47888392159554: window.nema_onefourfivezero_smartsplitteronly,
            48113002119490: window.nema_onefourfivezero_teslaprobundle,
            50766355169602: window.nema_sixfivezero_first,
            50766355202370: window.nema_sixfivezero_second,
            47888154362178: window.nema_tenfivezero_first
          };
          if (bundleVariants[variant.id]) {
            variantClone.innerHTML += `<div>${bundleVariants[variant.id]}</div>`;
          }
          variantContainer.appendChild(variantClone);
          const variantRadio = variantClone.querySelector(".variant-option");
          if (index === 0) {
            variantRadio.checked = true;
            selectedVariantId = variant.id;
            updateVariantImage(variant);
            updateActiveClass(variantRadio, ".variant-option");
          }
          variantRadio.addEventListener("change", function () {
            selectedVariantId = this.value;
            updateVariantImage(variant);
            updateActiveClass(variantRadio, ".variant-option");
          });
        });
      })
      .catch(error => console.error("Error fetching product data:", error));
  }

  function updateVariantImage(variant) {
    if (variant.featured_image) {
      mainImageContainer.src = variant.featured_image.src;
    }
  }

  // Updated function to add activbep along with other active classes
  function updateActiveClass(selectedElement, selector) {
    document.querySelectorAll(selector).forEach((el) => {
      el.classList.remove("yep-active", "activbep");
      const parent = el.closest("label, div");
      if (parent) {
        parent.classList.remove("active-p", "activbep");
      }
    });
    selectedElement.classList.add("yep-active", "activbep");
    const parentElement = selectedElement.closest("label, div");
    if (parentElement) {
      parentElement.classList.add("active-p", "activbep");
    }
  }

  productOptions.forEach((radio) => {
    radio.addEventListener("change", function () {
      updateGallery(this.value);
      updateActiveClass(this, ".product-option");
    });
  });
  assignedProductOptions.forEach((radio) => {
    radio.addEventListener("change", function () {
      updateGallery(this.value);
      updateActiveClass(this, ".product-optione");
    });
  });
  const defaultSelected = document.querySelector('#product_option_1');
  if (defaultSelected) {
    defaultSelected.checked = true;
    defaultSelected.dispatchEvent(new Event("change"));
  }
  if (backStepButton) {
    backStepButton.addEventListener("click", function () {
      productOptions.forEach((radio) => radio.checked = false);
      assignedProductOptions.forEach((radio) => radio.checked = false);
      document.querySelectorAll('.variant-option').forEach((radio) => radio.checked = false);
      selectedVariantId = null;
      clearGalleryAndVariants();
      document.querySelectorAll(".yep-active").forEach((el) => el.classList.remove("yep-active"));
      document.querySelectorAll(".active-p").forEach((el) => el.classList.remove("active-p"));
      const defaultOption = document.querySelector('#product_option_1');
      if (defaultOption) {
        defaultOption.checked = true;
        defaultOption.dispatchEvent(new Event("change"));
      }
      // Scroll back to saved scroll position on back-step click.
      window.scrollTo({ top: savedScrollPos, behavior: "smooth" });
    });
  }
  if (nextStepButton) {
    nextStepButton.addEventListener("click", function () {
      if (!selectedVariantId) {
        return;
      }
      document.getElementById("step-1").classList.remove("acti-here");
      document.getElementById("step-2").classList.add("acti-here");
      // Scroll to top on next-step click.
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
  if (checkoutButton) {
    checkoutButton.addEventListener("click", function () {
      if (!selectedVariantId) {
        alert("Please select a variant before proceeding to checkout.");
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quantity: 1, id: selectedVariantId })
      })
      .then(() => window.location.href = "/checkout")
      .catch(error => console.error("Error adding product to cart:", error));
    });
  }
});

//
// New update for toggling boxes
document.addEventListener("DOMContentLoaded", function () {
  console.log("MM box");
  const firstBox = document.querySelector(".first-box");
  const secondBox = document.querySelector(".second-box");
  const nema1030 = document.querySelector("#nema-10-30");
  const nema1430 = document.querySelector("#nema-14-30");
  function toggleActive(activeBox, inactiveBox) {
    console.log("MM sss");
    inactiveBox.classList.remove("active-box");
    activeBox.classList.add("active-box");
  }
  nema1030.addEventListener("click", function () {
    toggleActive(firstBox, secondBox);
  });
  nema1430.addEventListener("click", function () {
    toggleActive(secondBox, firstBox);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  console.log("✅ JavaScript Loaded!");
  document.addEventListener("click", (event) => {
    const bHeadingContent = event.target.closest(".b-heading-content[data-index='3']");
    if (!bHeadingContent) return;
    console.log("🖱️ Click detected inside .b-heading-content[data-index='3']");
    let clickedButton = event.target.closest("[id]");
    if (!clickedButton) {
      console.warn("⚠️ No valid button ID detected.");
      return;
    }
    const buttonID = clickedButton.id;
    console.log(`🔹 Clicked button ID: ${buttonID}`);
    const boxMappings = {
      "option-1-3": "fir-box",
      "option-2-3": "se-box",
      "option-3-3": "th-box",
      "option-4-3": "fo-box",
      "option-5-3": "fi-box"
    };
    const targetBoxClass = boxMappings[buttonID];
    if (!targetBoxClass) {
      console.warn(`❌ Button ID '${buttonID}' is not in boxMappings.`);
      return;
    }
    const mainnsBox = document.querySelector(".mainns-boxx[data-index='3']");
    if (!mainnsBox) {
      console.warn("⚠️ .mainns-boxx[data-index='3'] not found.");
      return;
    }
    console.log(`🎯 Targeting .${targetBoxClass} inside .mainns-boxx[data-index='3']`);
    mainnsBox.querySelectorAll(".fir-box, .se-box, .th-box, .fo-box, .fi-box").forEach(box =>
      box.classList.remove("active-box")
    );
    const targetBox = mainnsBox.querySelector(`.${targetBoxClass}`);
    if (targetBox) {
      targetBox.classList.add("active-box");
      console.log(`✅ Added .active-box to .${targetBoxClass}`);
    } else {
      console.warn(`❌ Target box .${targetBoxClass} not found.`);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  console.log("🚀 Script Loaded - Ready to Detect Clicks");
  document.querySelector("#variant-container").addEventListener("click", function (event) {
    let target = event.target.closest("span.second-var-first input[data-index]");
    if (!target) return;
    let index = target.getAttribute("data-index");
    console.log("🖱️ Click detected on variant option");
    console.log("➡️ Clicked variant option with index:", index);
    document.querySelectorAll('.mainns-boxx[data-index="3"] .main-box .box-text').forEach(el => el.classList.remove("active-boxi"));
    console.log("🔸 Removed .active-boxi from all .box-text elements");
    let targetBoxText = document.querySelector(`.mainns-boxx[data-index="3"] .main-box .box-text[data-index="${index}"]`);
    if (targetBoxText) {
      targetBoxText.classList.add("active-boxi");
      console.log(`✅ Added .active-boxi to .box-text[data-index="${index}"]`);
    } else {
      console.error(`❌ No matching .box-text[data-index="${index}"] found`);
    }
  });
});

$(window).on('load', function () {
  setTimeout(function () {
    initializeSlider();
    observeActiveSlideChange();
  }, 500);
});

// =============================
// Slider Initialization & Observing
// =============================

// This function clones images from the movable images container into the thumbnail container,
// then always removes and re-inserts the arrow buttons.
function initializeSlider() {
  var $activeSlide = $('.slide.active-slider-gallery');
  if ($activeSlide.length) {
    var $movableImages = $activeSlide.find('.movable-div-imgs img');

    // If no images are found, wait and try again
    if ($movableImages.length === 0) {
      console.warn("No movable images found. Retrying in 100ms...");
      setTimeout(initializeSlider, 100);
      return;
    }

    var $thumbContainer = $activeSlide.find('.thumbnail-container');

    // Clone images from movable-div-imgs into thumbnail-container
    $thumbContainer.empty();
    $movableImages.each(function () {
      $(this).clone().appendTo($thumbContainer);
    });

    var $firstThumb = $thumbContainer.find('img').first();
    if ($firstThumb.length) {
      var $clone = $firstThumb.clone();
      $activeSlide.find('.main-image-container').empty().append($clone);
      $firstThumb.addClass('active-thumbnail');
    }

    // Bind click event for thumbnail images inside the active slide
    $thumbContainer.off('click').on('click', 'img', function () {
      $thumbContainer.find('img').removeClass('active-thumbnail');
      $(this).addClass('active-thumbnail');

      var $newClone = $(this).clone();
      $activeSlide.find('.main-image-container').empty().append($newClone);
    });

    // Remove all existing arrow buttons within the active slide
    $activeSlide.find('button.thumbnail-prev, button.thumbnail-next').remove();

    // Insert arrow buttons
    var $prevArrow = $('<button class="thumbnail-prev" style="display: block;">←</button>');
    var $nextArrow = $('<button class="thumbnail-next" style="display: block;">→</button>');
    $prevArrow.insertBefore($activeSlide.find('.thumbnail-gallery .thumbnail-container'));
    $nextArrow.insertAfter($activeSlide.find('.thumbnail-gallery .movable-div-imgs'));
    
    // Define mobile check function
    function isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    }
    
    // Arrow click events: always check isMobile() on click
    $prevArrow.on('click', function() {
      if(isMobile()){
          $thumbContainer.animate({scrollTop: $thumbContainer.scrollTop() - 100}, 300);
      } else {
          $thumbContainer.animate({scrollLeft: $thumbContainer.scrollLeft() - 100}, 300);
      }
    });
    $nextArrow.on('click', function() {
      if(isMobile()){
          $thumbContainer.animate({scrollTop: $thumbContainer.scrollTop() + 100}, 300);
      } else {
          $thumbContainer.animate({scrollLeft: $thumbContainer.scrollLeft() + 100}, 300);
      }
    });
  }
}

// Function to watch for active slide changes
function observeActiveSlideChange() {
  var previousActiveSlide = null;
  var observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.attributeName === "class") {
        var target = $(mutation.target);
        if (target.hasClass("active-slider-gallery") && target[0] !== previousActiveSlide) {
          previousActiveSlide = target[0]; // Update the active slide reference
          $('.slide').removeData('initialized'); // Reset initialization flag for all slides
          initializeSlider(); // Initialize the new active slide
        }
      }
    });
  });
  $('.slide').each(function () {
    observer.observe(this, { attributes: true, attributeFilter: ['class'] });
  });
}

// Reinitialize slider on certain click events
$('.block-ctn, .label-pp, #next-step').on('click', function(){
  initializeSlider();
});

$(window).on('load', function () {
  setTimeout(function () {
    initializeSlider();
    observeActiveSlideChange();
  }, 500);
});